import type { IOrderMSServiceNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createOrderMSServiceNote,
  updateNote: updateOrderMSServiceNote,
  deleteNote: deleteOrderMSServiceNote,
} = makeNoteService<IOrderMSServiceNote>(
  '/api/ordermsservicenotes',
  'orderMSServiceNote'
)
